import type { IconSvgObject } from './types';

const AlignBoxBottomLeftIcon: IconSvgObject = [
  ["path", { d: "M5.5 22C4.39543 22 3.5 21.1046 3.5 20L3.5 4.0017C3.5 2.89647 4.39647 2.00076 5.5017 2.0017L18.5017 2.01277C19.6056 2.01371 20.5 2.90886 20.5 4.01277L20.5 20C20.5 21.1046 19.6046 22 18.5 22H5.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 12H7M11 17H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AlignBoxBottomLeftIcon;
